export const AFFILIATE_PORTAL_PATH_PREFIX = "/affiliate-portal";

export const AFFILIATE_PORTAL_SIGN_IN_ROUTE =
  `${AFFILIATE_PORTAL_PATH_PREFIX}/sign-in`;

export const AFFILIATE_PORTAL_SET_PASSWORD_ROUTE =
  `${AFFILIATE_PORTAL_PATH_PREFIX}/set-password`;

export const AFFILIATE_PORTAL_DASHBOARD_ROUTE =
  `${AFFILIATE_PORTAL_PATH_PREFIX}/dashboard`;

export const isAffiliatePortalPath = (pathname: string): boolean =>
  pathname === AFFILIATE_PORTAL_PATH_PREFIX ||
  pathname.startsWith(`${AFFILIATE_PORTAL_PATH_PREFIX}/`);
